'use client';

import React, { useCallback } from 'react';

/**
 * Quiz question — "Gallery · Field" design (qz-opts / qz-opt).
 * Logic unchanged; only the markup/styling is GF.
 */
export default function QuizQuestion({
    question,
    lang,
    selectedAnswers = [],
    onAnswerChange,
    translations,
}) {
    const questionText = question.question[lang];
    const options = question.options[lang];

    const handleOptionClick = useCallback((optionIndex) => {
        if (question.multipleChoice) {
            const newAnswers = selectedAnswers.includes(optionIndex)
                ? selectedAnswers.filter((a) => a !== optionIndex)
                : [...selectedAnswers, optionIndex];
            onAnswerChange(newAnswers);
        } else {
            onAnswerChange([optionIndex]);
        }
    }, [question.multipleChoice, selectedAnswers, onAnswerChange]);

    const handleKeyDown = useCallback((e, optionIndex) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleOptionClick(optionIndex);
        }
    }, [handleOptionClick]);

    return (
        <>
            <h2 className="qz-q">{questionText}</h2>
            {question.multipleChoice && <p className="qz-hint">{`// ${translations.multipleChoice}`}</p>}
            <div className="qz-opts" role={question.multipleChoice ? 'group' : 'radiogroup'} aria-label={questionText}>
                {options.map((option, index) => {
                    const selected = selectedAnswers.includes(index);
                    return (
                        <button
                            key={index}
                            type="button"
                            className={`qz-opt ${selected ? 'on' : ''}`}
                            onClick={() => handleOptionClick(index)}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            aria-pressed={selected}
                            role={question.multipleChoice ? 'checkbox' : 'radio'}
                            aria-checked={selected}
                        >
                            <span className="tick"><svg viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" strokeLinecap="round" strokeLinejoin="round" /></svg></span>
                            <span>{option}</span>
                        </button>
                    );
                })}
            </div>
        </>
    );
}
